import Vue from 'vue'
import App from './App.vue'
import router from './router'

// need this to kick off PostCSS
import './main.css'

Vue.config.productionTip = false

// Vue.prototype.$isUK = ( window.location.hostname.substr( -2 ) === '55' ) // laptup IP locally when testing
Vue.prototype.$isUK = ( window.location.hostname.substr( -2 ) === 'uk' )


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
